exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-card-header-blue[data-v-54b5b89d]  .card-icon {\n  color: #fff;\n}\n", ""]);

// exports
